import { Predicates } from "../libraries/predicates/predicates";
import { IConsumerType } from "../types/data.interface";

export const formatConsumerTypeIntoOption = (
  item: IConsumerType | null,
) => {
  return Predicates.isNotNullAndNotUndefined(item)
    ? {
        value: item,
        label: `${item.name}`,
      }
    : null;
};

export const getConsumerTypes = (
  consumerTypes: IConsumerType[],
) =>
  consumerTypes
    .map(formatConsumerTypeIntoOption)
    .filter(Predicates.isNotNullAndNotUndefined)
    .sort((a, b) => {
      if (a.value.id === 0) return -1;
      if (b.value.id === 0) return 1;
      return 0;
    });
